import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import _ from 'lodash';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getAllowedToSpeakListBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder.addCase(actions.getAllowedToSpeakList.fulfilled, (state, action) => {
    const newData = JSON.parse(action.payload.data.custom?.listenersAllowedToSpeak || '[]');

    if (!_.isEqual(newData, state.listenersAllowedToSpeak)) {
      state.listenersAllowedToSpeak = newData;
    }
    state.isBusy = false;
  });
};
